module.exports = __webpack_public_path__ + "16_hair_silver.63c7815c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/16_hair_silver.png
// module id = UXn4
// module chunks = 0